import { Group } from '@optiaxiom/react';
import { QuickstartCard } from './QuickstartCard';
import { SecurityBestPractices } from './SecurityBestPractices';

/**
 * Shown when the developer already has an API key: a quickstart for using it
 * with the OCP CLI, plus security guidance. The page header (title + subtitle +
 * "Regenerate API Key") is rendered by ApiKeyPage.
 */
export function ApiKeyActiveState() {
  return (
    <Group flexDirection="column" gap="24" alignItems="stretch" mt="24">
      <QuickstartCard />
      <SecurityBestPractices />
    </Group>
  );
}
